<div class="row dashboard-columns d-none d-lg-flex safe-area-bottom">
    <div class="col todays-assignments">
        <!-- todays assignments -->
        <pace-notification-list
            [model]="model.todaysAssignments"
            [title]="strings.todaysTitle"
        ></pace-notification-list>
    </div>
    <div class="col upcoming-assignments">
        <!-- upcoming assignments -->
        <pace-notification-list
            [model]="model.upcomingAssignments"
            [title]="strings.upcomingTitle"
        ></pace-notification-list>
    </div>
    <div class="col new-assignments">
        <!-- new assignments -->
        <pace-notification-list [model]="model.newAssignments" [title]="strings.newTitle"></pace-notification-list>
    </div>
</div>

<tabset
    #tabSet
    paceCoreTabsRole
    class="d-block d-lg-none dashboard-tab-container-sm mh-100 overflow-y-auto overflow-x-hidden pb-5 pt-2 px-2"
>
    <tab [heading]="strings.todaysTitleOnSmartphone">
        <pace-notification-list [model]="model.todaysAssignments"></pace-notification-list>
    </tab>
    <tab [heading]="strings.upcomingTitleOnSmartphone">
        <pace-notification-list [model]="model.upcomingAssignments"></pace-notification-list>
    </tab>
    <tab
        [heading]="strings.newTitleOnSmartphone"
        [customClass]="(newAssignmentsCount$ | async) ? 'new-tab' : 'new-empty-tab'"
    >
        <pace-notification-list [model]="model.newAssignments"></pace-notification-list>
    </tab>
</tabset>
